import React from 'react'

import browserUpdate from 'browser-update'
import invariant from 'invariant'
import {createRoot} from 'react-dom/client'
import {BrowserRouter} from 'react-router'

import '../../commons/src/styles/layers.scss'

import './styles/main.scss'

import config from './config'

import StoreProvider from './containers/store-provider'

import {onInteract} from '../../commons/src/services/critical'
import * as dixa from '../../commons/src/services/dixa'
import * as elevio from '../../commons/src/services/elevio'
import {initLogging} from './services/logging'

import MainApp from './containers/app'

// Initialize Sentry
if (config.sentry.enabled) {
  initLogging(config.sentry.dsn, config.sentry.release, config.sentry.environment)
}

function renderApp(Content: React.ComponentType) {
  const App = () => (
    <StoreProvider>
      <BrowserRouter>
        <Content />
      </BrowserRouter>
    </StoreProvider>
  )

  const rootElement = window.document.getElementById('root')
  invariant(rootElement, 'Root element #root not found.')
  const root = createRoot(rootElement, {identifierPrefix: 'manufacturer-portal-'})

  root.render(<App />)
}

renderApp(MainApp)

onInteract(() => {
  dixa.init(config.dixa.enabled, config.dixa.setDefaultUser)
  elevio.init(config.elevio)
})

// Webpack (uglify) will remove this code in the production build
if (process.env.NODE_ENV !== 'production') {
  console.info('NODE_ENV', process.env.NODE_ENV) // eslint-disable-line no-console

  if (module.hot) {
    // Enable Webpack hot module replacement
    module.hot.accept(['./containers/app'], () => {
      // eslint-disable-next-line @typescript-eslint/no-require-imports
      renderApp(require('./containers/app').default)
    })
  }
} else {
  // In production version only
  browserUpdate({required: {e: -2, i: 0, f: -2, o: -2, s: -2, c: -2}}) // Warn outdated browsers
}
